export const state = {
  opportunities: [],
  isLoading: false,
  totalRecords: 0,
  opportunityPerPage: 10000,
  activePage: 1
}
